package com.shadowings.gero.data.lessons.chapter6

import com.shadowings.gero.data.lessons.frenchClause
import com.shadowings.gero.data.lessons.inlineMeaning
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.Option
import com.shadowings.gero.domain.model.PhoneticKeyboardContent
import com.shadowings.gero.domain.model.QuizText
import com.shadowings.gero.domain.model.SingleSelectionContent
import com.shadowings.gero.domain.model.VerbSentence
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_formare_verbi_alyn_1
import gero.composeapp.generated.resources.exp_content_formare_verbi_alyn_2
import gero.composeapp.generated.resources.exp_content_formare_verbi_alyn_3
import gero.composeapp.generated.resources.exp_content_formare_verbi_alyn_4
import gero.composeapp.generated.resources.exp_content_formare_verbi_alyn_5
import gero.composeapp.generated.resources.exp_content_formare_verbi_es1
import gero.composeapp.generated.resources.exp_content_formare_verbi_es2
import gero.composeapp.generated.resources.exp_content_formare_verbi_es3
import gero.composeapp.generated.resources.exp_content_formare_verbi_es4
import gero.composeapp.generated.resources.exp_content_formare_verbi_nilo_comment
import gero.composeapp.generated.resources.exp_content_formare_verbi_nilo_comment_2
import gero.composeapp.generated.resources.exp_content_formare_verbi_zeta_1
import gero.composeapp.generated.resources.exp_content_formare_verbi_zeta_2
import gero.composeapp.generated.resources.exp_content_formare_verbi_zeta_3
import gero.composeapp.generated.resources.exp_content_formare_verbi_zeta_4
import gero.composeapp.generated.resources.exp_title_formare_verbi
import gero.composeapp.generated.resources.exp_title_formare_verbi_2_lit
import gero.composeapp.generated.resources.exp_title_formare_verbi_2ae_gem
import gero.composeapp.generated.resources.exp_title_formare_verbi_3_lit
import gero.composeapp.generated.resources.exp_title_formare_verbi_3ae_inf
import gero.composeapp.generated.resources.quiz_ripasso_cosa_significa_gero
import gero.composeapp.generated.resources.quiz_ripasso_quale_gero_significa

fun getFormarVerbaContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_formare_verbi,
            content = Res.string.exp_content_formare_verbi_alyn_1,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_formare_verbi,
            content = Res.string.exp_content_formare_verbi_alyn_2,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_formare_verbi,
            content = Res.string.exp_content_formare_verbi_zeta_1,
            face = Faces.Happy,
            character = Characters.Zeta,
            composable = {
                MdCWord(
                    word = "M17-X1D46",
                    rtl = false,
                    cart = false
                )
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_formare_verbi,
            content = Res.string.exp_content_formare_verbi_zeta_2,
            face = Faces.Happy,
            character = Characters.Zeta,
            composable = {
                MdCWord(
                    word = "E34:N35:N35",
                    rtl = false,
                    cart = false
                )
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_formare_verbi,
            content = Res.string.exp_content_formare_verbi_zeta_3,
            face = Faces.Happy,
            character = Characters.Zeta,
            composable = {
                MdCWord(
                    word = "O1:D21-D54",
                    rtl = false,
                    cart = false
                )
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_formare_verbi,
            content = Res.string.exp_content_formare_verbi_alyn_3,
            face = Faces.Serious,
            character = Characters.Alyn,
            composable = {
                MdCWord(
                    word = "X8",
                    rtl = false,
                    cart = false
                )
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_formare_verbi,
            content = Res.string.exp_content_formare_verbi_alyn_4,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_formare_verbi,
            content = Res.string.exp_content_formare_verbi_es4,
            face = Faces.Idle,
            character = Characters.Alyn
        ),
        ExplanationContent(
            title = Res.string.exp_title_formare_verbi_2_lit,
            content = Res.string.exp_content_formare_verbi_es1,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = {
                MdCWord(
                    word = "X1D46-I9",
                    rtl = false,
                    cart = false
                )
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_formare_verbi_3_lit,
            content = Res.string.exp_content_formare_verbi_es2,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = {
                MdCWord(
                    word = "O34-G36:D21-A2-N35:Z2",
                    rtl = false,
                    cart = false
                )
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_formare_verbi,
            content = Res.string.exp_content_formare_verbi_nilo_comment,
            face = Faces.Serious,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_formare_verbi_2ae_gem,
            content = Res.string.exp_content_formare_verbi_es3,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = {
                MdCWord(
                    word = "E34:N35:N35-S29-N35",
                    rtl = false,
                    cart = false
                )
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_formare_verbi,
            content = Res.string.exp_content_formare_verbi_nilo_comment_2,
            face = Faces.Serious,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_formare_verbi_3ae_inf,
            content = Res.string.exp_content_formare_verbi_alyn_5,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = {
                MdCWord(
                    word = "O1:D21-D54-A1",
                    rtl = false,
                    cart = false
                )
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_formare_verbi,
            content = Res.string.exp_content_formare_verbi_zeta_4,
            face = Faces.Happy,
            character = Characters.Zeta,
        )
    )
}

fun getFormarVerbaQuiz(
    words: List<Word>,
    verbs: List<Verb>,
    languageCode: String
): List<IQuizContent> {
    val verbKeysToUse = listOf(
        "MANGIARE",
        "DARE",
        "ASCOLTARE",
        "DIRE",
        "BERE",
        "USCIRE",
        "ENTRARE",
        "AMARE",
        "ESISTERE",
        "VOLARE"
    ).shuffled()
    val pronouns = listOf(
        "IO", "TU_M", "TU_F", "EGLI", "ELLA", "ESSO", "NOI", "VOI", "ESSI"
    )

    val keyboardQuiz = verbKeysToUse.take(3).map { verbKey ->
        val result = getRandomImperfectiveConjugation(verbKey, pronouns, words, verbs, languageCode)
        PhoneticKeyboardContent(
            sentence = result.hieroglyphs,
            info = "${result.transliteration} -> ${result.sentence}",
            reading = result.transliteration.map { it.toString() },
            isProperName = false,
            canRotate = false
        )
    }

    val selectReadingQuizzes = verbKeysToUse.drop(3).take(3).map { verbKey ->
        val result = getRandomImperfectiveConjugation(verbKey, pronouns, words, verbs, languageCode)
        val options = mutableListOf(Option(text = result.hieroglyphs, correct = true))

        while (true) {
            val randomVerbKey = verbKeysToUse.random()
            val randomResult = getRandomImperfectiveConjugation(
                randomVerbKey,
                pronouns,
                words,
                verbs,
                languageCode
            )
            if (options.none { (it.text as QuizText.Plain).text == randomResult.hieroglyphs }) {
                options.add(Option(text = randomResult.hieroglyphs, correct = false))
            }
            if (options.size == 4) break
        }

        SingleSelectionContent(
            text = Res.string.quiz_ripasso_quale_gero_significa,
            textArgs = listOf(result.sentence),
            detail = "",
            options = options.shuffled()
        )
    }

    val selectMeaningQuizzes = verbKeysToUse.drop(6).map { verbKey ->
        val result = getRandomImperfectiveConjugation(verbKey, pronouns, words, verbs, languageCode)
        val options = mutableListOf(Option(text = result.sentence, correct = true))

        while (true) {
            val randomVerbKey = verbKeysToUse.random()
            val randomResult = getRandomImperfectiveConjugation(
                randomVerbKey,
                pronouns,
                words,
                verbs,
                languageCode
            )
            if (options.none { (it.text as QuizText.Plain).text == randomResult.sentence }) {
                options.add(Option(text = randomResult.sentence, correct = false))
            }
            if (options.size == 4) break
        }

        SingleSelectionContent(
            text = Res.string.quiz_ripasso_cosa_significa_gero,
            detail = result.hieroglyphs,
            options = options.shuffled()
        )
    }

    return keyboardQuiz + selectReadingQuizzes + selectMeaningQuizzes
}

fun getRandomImperfectiveConjugation(
    verbKey: String,
    pronouns: List<String>,
    words: List<Word>,
    verbs: List<Verb>,
    languageCode: String
): VerbSentence {
    val randomPronoun = pronouns.random()
    val pronunciesWord = words.first { it.id == randomPronoun }
    val pronounTranslation = pronunciesWord.inlineMeaning(languageCode)
    val pronounHiero = pronunciesWord.gardiner
    val pronounTrans = pronunciesWord.reading

    // Cerco il verbo dalla lista dei verbi caricati
    val verb = verbs.firstOrNull { it.chiaveWords == verbKey }
        ?: error("Verbo $verbKey non trovato")

    // Costruisco i geroglifici: ${forma_imperfettiva}-${determinativo} (se != "-")-${gardiner pronome}
    val hieroglyphs = if (verb.determinativo != "-") {
        "${verb.formaImperfettiva}-${verb.determinativo}-${pronounHiero}"
    } else {
        "${verb.formaImperfettiva}-${pronounHiero}"
    }

    // Costruisco la traslitterazione: ${traslitterazione_imperfettiva}.${traslitterazione pronome}
    val transliteration = "${verb.traslitterazioneImperfettiva}.${pronounTrans}"

    val sentence = when (languageCode) {
        "it" -> conjugateVerbIt(
            verb = verbKey,
            pronoun = randomPronoun
        )

        "de" -> conjugateVerbDe(
            verb = verbKey,
            pronoun = randomPronoun
        )

        "es" -> conjugateVerbEs(
            verb = verbKey,
            pronoun = randomPronoun
        )

        "fr" -> conjugateVerbFr(
            verb = verbKey,
            pronoun = randomPronoun
        )

        else -> conjugateVerbEn(
            verb = verbKey,
            pronoun = randomPronoun
        )
    }

    return VerbSentence(
        hieroglyphs = hieroglyphs,
        sentence = if (languageCode == "fr") frenchClause(pronounTranslation, sentence) else "$pronounTranslation $sentence",
        transliteration = transliteration
    )
}

private fun normalizePronounKey(pronoun: String): String = when (pronoun.trim().uppercase()) {
    "IO", "ICH", "I", "YO" -> "IO"
    "TU_M", "TU_F", "TU", "DU", "YOU", "TÚ", "TU_MASC", "TU_FEM" -> "TU_M"
    "EGLI", "ELLA", "ESSO", "ER", "SIE", "ES", "HE", "SHE", "IT", "ÉL", "ELLO", "LUI", "LEI" -> "EGLI"
    "NOI", "WIR", "WE", "NOSOTROS", "NOSOTRAS" -> "NOI"
    "VOI", "IHR", "YOU_ALL", "VOSOTROS", "VOSOTRAS" -> "VOI"
    "ESSI", "THEY", "ELLOS", "ELLAS", "LORO" -> "ESSI"
    else -> if (pronoun.trim().endsWith("I") || pronoun.trim().endsWith("E") || pronoun.trim()
            .endsWith("S") || pronoun.trim().endsWith("EN")
    ) "ESSI" else "EGLI"
}

fun conjugateVerbIt(verb: String, pronoun: String): String {
    val pronoun = normalizePronounKey(pronoun)
    when (verb) {
        "MANGIARE" -> {
            return when (pronoun) {
                "IO" -> "mangio"
                "TU_M", "TU_F" -> "mangi"
                "EGLI", "ELLA", "ESSO" -> "mangia"
                "NOI" -> "mangiamo"
                "VOI" -> "mangiate"
                "ESSI" -> "mangiano"
                else -> verb
            }
        }

        "DARE" -> {
            return when (pronoun) {
                "IO" -> "do"
                "TU_M", "TU_F" -> "dai"
                "EGLI", "ELLA", "ESSO" -> "dà"
                "NOI" -> "diamo"
                "VOI" -> "date"
                "ESSI" -> "danno"
                else -> verb
            }
        }

        "ASCOLTARE" -> {
            return when (pronoun) {
                "IO" -> "ascolto"
                "TU_M", "TU_F" -> "ascolti"
                "EGLI", "ELLA", "ESSO" -> "ascolta"
                "NOI" -> "ascoltiamo"
                "VOI" -> "ascoltate"
                "ESSI" -> "ascoltano"
                else -> verb
            }
        }

        "DIRE" -> {
            return when (pronoun) {
                "IO" -> "dico"
                "TU_M", "TU_F" -> "dici"
                "EGLI", "ELLA", "ESSO" -> "dice"
                "NOI" -> "diciamo"
                "VOI" -> "dite"
                "ESSI" -> "dicono"
                else -> verb
            }
        }

        "BERE" -> {
            return when (pronoun) {
                "IO" -> "bevo"
                "TU_M", "TU_F" -> "bevi"
                "EGLI", "ELLA", "ESSO" -> "beve"
                "NOI" -> "beviamo"
                "VOI" -> "bevete"
                "ESSI" -> "bevono"
                else -> verb
            }
        }

        "USCIRE" -> {
            return when (pronoun) {
                "IO" -> "esco"
                "TU_M", "TU_F" -> "esci"
                "EGLI", "ELLA", "ESSO" -> "esce"
                "NOI" -> "usciamo"
                "VOI" -> "uscite"
                "ESSI" -> "escono"
                else -> verb
            }
        }

        "ENTRARE" -> {
            return when (pronoun) {
                "IO" -> "entro"
                "TU_M", "TU_F" -> "entri"
                "EGLI", "ELLA", "ESSO" -> "entra"
                "NOI" -> "entriamo"
                "VOI" -> "entrate"
                "ESSI" -> "entrano"
                else -> verb
            }
        }

        "AMARE" -> {
            return when (pronoun) {
                "IO" -> "amo"
                "TU_M", "TU_F" -> "ami"
                "EGLI", "ELLA", "ESSO" -> "ama"
                "NOI" -> "amiamo"
                "VOI" -> "amate"
                "ESSI" -> "amano"
                else -> verb
            }
        }

        "ESISTERE" -> {
            return when (pronoun) {
                "IO" -> "esisto"
                "TU_M", "TU_F" -> "esisti"
                "EGLI", "ELLA", "ESSO" -> "esiste"
                "NOI" -> "esistiamo"
                "VOI" -> "esistete"
                "ESSI" -> "esistono"
                else -> verb
            }
        }

        "VOLARE" -> {
            return when (pronoun) {
                "IO" -> "volo"
                "TU_M", "TU_F" -> "voli"
                "EGLI", "ELLA", "ESSO" -> "vola"
                "NOI" -> "voliamo"
                "VOI" -> "volate"
                "ESSI" -> "volano"
                else -> verb
            }
        }

        "COLTIVARE" -> {
            return when (pronoun) {
                "IO" -> "coltivo"
                "TU_M", "TU_F" -> "coltivi"
                "EGLI", "ELLA", "ESSO" -> "coltiva"
                "NOI" -> "coltiviamo"
                "VOI" -> "coltivate"
                "ESSI" -> "coltivano"
                else -> verb
            }
        }

        "CACCIARE" -> {
            return when (pronoun) {
                "IO" -> "caccio"
                "TU_M", "TU_F" -> "cacci"
                "EGLI", "ELLA", "ESSO" -> "caccia"
                "NOI" -> "cacciamo"
                "VOI" -> "cacciate"
                "ESSI" -> "cacciano"
                else -> verb
            }
        }

        "OFFRIRE" -> {
            return when (pronoun) {
                "IO" -> "offro"
                "TU_M", "TU_F" -> "offri"
                "EGLI", "ELLA", "ESSO" -> "offre"
                "NOI" -> "offriamo"
                "VOI" -> "offrite"
                "ESSI" -> "offrono"
                else -> verb
            }
        }

        "SCRIVERE" -> {
            return when (pronoun) {
                "IO" -> "scrivo"
                "TU_M", "TU_F" -> "scrivi"
                "EGLI", "ELLA", "ESSO" -> "scrive"
                "NOI" -> "scriviamo"
                "VOI" -> "scrivete"
                "ESSI" -> "scrivono"
                else -> verb
            }
        }

        "VEDERE" -> {
            return when (pronoun) {
                "IO" -> "vedo"
                "TU_M", "TU_F" -> "vedi"
                "EGLI", "ELLA", "ESSO" -> "vede"
                "NOI" -> "vediamo"
                "VOI" -> "vedete"
                "ESSI" -> "vedono"
                else -> verb
            }
        }

        "PARLARE" -> {
            return when (pronoun) {
                "IO" -> "parlo"
                "TU_M", "TU_F" -> "parli"
                "EGLI", "ELLA", "ESSO" -> "parla"
                "NOI" -> "parliamo"
                "VOI" -> "parlate"
                "ESSI" -> "parlano"
                else -> verb
            }
        }

        "TROVARE" -> {
            return when (pronoun) {
                "IO" -> "trovo"
                "TU_M", "TU_F" -> "trovi"
                "EGLI", "ELLA", "ESSO" -> "trova"
                "NOI" -> "troviamo"
                "VOI" -> "trovate"
                "ESSI" -> "trovano"
                else -> verb
            }
        }

        "FARE" -> {
            return when (pronoun) {
                "IO" -> "faccio"
                "TU_M", "TU_F" -> "fai"
                "EGLI", "ELLA", "ESSO" -> "fa"
                "NOI" -> "facciamo"
                "VOI" -> "fate"
                "ESSI" -> "fanno"
                else -> verb
            }
        }

        "PORTARE" -> {
            return when (pronoun) {
                "IO" -> "porto"
                "TU_M", "TU_F" -> "porti"
                "EGLI", "ELLA", "ESSO" -> "porta"
                "NOI" -> "portiamo"
                "VOI" -> "portate"
                "ESSI" -> "portano"
                else -> verb
            }
        }

        "CONOSCERE" -> {
            return when (pronoun) {
                "IO" -> "conosco"
                "TU_M", "TU_F" -> "conosci"
                "EGLI", "ELLA", "ESSO" -> "conosce"
                "NOI" -> "conosciamo"
                "VOI" -> "conoscete"
                "ESSI" -> "conoscono"
                else -> verb
            }
        }

        "ANDARE" -> {
            return when (pronoun) {
                "IO" -> "vado"
                "TU_M", "TU_F" -> "vai"
                "EGLI", "ELLA", "ESSO" -> "va"
                "NOI" -> "andiamo"
                "VOI" -> "andate"
                "ESSI" -> "vanno"
                else -> verb
            }
        }

        "INVIARE" -> {
            return when (pronoun) {
                "IO" -> "invio"
                "TU_M", "TU_F" -> "invii"
                "EGLI", "ELLA", "ESSO" -> "invia"
                "NOI" -> "inviamo"
                "VOI" -> "inviate"
                "ESSI" -> "inviano"
                else -> verb
            }
        }

        "PRENDERE" -> {
            return when (pronoun) {
                "IO" -> "prendo"
                "TU_M", "TU_F" -> "prendi"
                "EGLI", "ELLA", "ESSO" -> "prende"
                "NOI" -> "prendiamo"
                "VOI" -> "prendete"
                "ESSI" -> "prendono"
                else -> verb
            }
        }

        "APRIRE" -> {
            return when (pronoun) {
                "IO" -> "apro"
                "TU_M", "TU_F" -> "apri"
                "EGLI", "ELLA", "ESSO" -> "apre"
                "NOI" -> "apriamo"
                "VOI" -> "aprite"
                "ESSI" -> "aprono"
                else -> verb
            }
        }

        "GUARDARE" -> {
            return when (pronoun) {
                "IO" -> "guardo"
                "TU_M", "TU_F" -> "guardi"
                "EGLI", "ELLA", "ESSO" -> "guarda"
                "NOI" -> "guardiamo"
                "VOI" -> "guardate"
                "ESSI" -> "guardano"
                else -> verb
            }
        }

        "CANTARE" -> {
            return when (pronoun) {
                "IO" -> "canto"
                "TU_M", "TU_F" -> "canti"
                "EGLI", "ELLA", "ESSO" -> "canta"
                "NOI" -> "cantiamo"
                "VOI" -> "cantate"
                "ESSI" -> "cantano"
                else -> verb
            }
        }

        "CHIAMARE" -> {
            return when (pronoun) {
                "IO" -> "chiamo"
                "TU_M", "TU_F" -> "chiami"
                "EGLI", "ELLA", "ESSO" -> "chiama"
                "NOI" -> "chiamiamo"
                "VOI" -> "chiamate"
                "ESSI" -> "chiamano"
                else -> verb
            }
        }

        "SIGILLARE" -> {
            return when (pronoun) {
                "IO" -> "sigillo"
                "TU_M", "TU_F" -> "sigilli"
                "EGLI", "ELLA", "ESSO" -> "sigilla"
                "NOI" -> "sigilliamo"
                "VOI" -> "sigillate"
                "ESSI" -> "sigillano"
                else -> verb
            }
        }

        "LAVORARE" -> {
            return when (pronoun) {
                "IO" -> "lavoro"
                "TU_M", "TU_F" -> "lavori"
                "EGLI", "ELLA", "ESSO" -> "lavora"
                "NOI" -> "lavoriamo"
                "VOI" -> "lavorate"
                "ESSI" -> "lavorano"
                else -> verb
            }
        }

        "SOLLEVARE" -> {
            return when (pronoun) {
                "IO" -> "sollevo"
                "TU_M", "TU_F" -> "sollevi"
                "EGLI", "ELLA", "ESSO" -> "solleva"
                "NOI" -> "solleviamo"
                "VOI" -> "sollevate"
                "ESSI" -> "sollevano"
                else -> verb
            }
        }

        "NAVIGARE" -> {
            return when (pronoun) {
                "IO" -> "navigo"
                "TU_M", "TU_F" -> "navighi"
                "EGLI", "ELLA", "ESSO" -> "naviga"
                "NOI" -> "navighiamo"
                "VOI" -> "navigate"
                "ESSI" -> "navigano"
                else -> verb
            }
        }

        "SPLENDERE" -> {
            return when (pronoun) {
                "IO" -> "splendo"
                "TU_M", "TU_F" -> "splendi"
                "EGLI", "ELLA", "ESSO" -> "splende"
                "NOI" -> "splendiamo"
                "VOI" -> "splendete"
                "ESSI" -> "splendono"
                else -> verb
            }
        }

        "PURIFICARE" -> {
            return when (pronoun) {
                "IO" -> "purifico"
                "TU_M", "TU_F" -> "purifichi"
                "EGLI", "ELLA", "ESSO" -> "purifica"
                "NOI" -> "purifichiamo"
                "VOI" -> "purificate"
                "ESSI" -> "purificano"
                else -> verb
            }
        }

        "ARROSTIRE" -> {
            return when (pronoun) {
                "IO" -> "arrostisco"
                "TU_M", "TU_F" -> "arrostisci"
                "EGLI", "ELLA", "ESSO" -> "arrostisce"
                "NOI" -> "arrostiamo"
                "VOI" -> "arrostite"
                "ESSI" -> "arrostiscono"
                else -> verb
            }
        }

        else -> return verb
    }
}

fun conjugateVerbEn(verb: String, pronoun: String): String {
    val pronoun = normalizePronounKey(pronoun)
    when (verb) {

        "PARLARE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "speaks"
                else -> "speak"
            }
        }

        "VEDERE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "sees"
                else -> "see"
            }
        }

        "SCRIVERE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "writes"
                else -> "write"
            }
        }

        "MANGIARE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "eats"
                else -> "eat"
            }
        }

        "DARE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "gives"
                else -> "give"
            }
        }

        "ASCOLTARE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "listens"
                else -> "listen"
            }
        }

        "DIRE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "says"
                else -> "say"
            }
        }

        "BERE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "drinks"
                else -> "drink"
            }
        }

        "USCIRE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "goes out"
                else -> "go out"
            }
        }

        "ENTRARE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "enters"
                else -> "enter"
            }
        }

        "AMARE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "loves"
                else -> "love"
            }
        }

        "ESISTERE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "exists"
                else -> "exist"
            }
        }

        "VOLARE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "flies"
                else -> "fly"
            }
        }

        "COLTIVARE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "cultivates"
                else -> "cultivate"
            }
        }

        "CACCIARE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "hunts"
                else -> "hunt"
            }
        }

        "OFFRIRE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "offers"
                else -> "offer"
            }
        }

        "TROVARE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "finds"
                else -> "find"
            }
        }

        "FARE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "makes"
                else -> "make"
            }
        }

        "PORTARE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "brings"
                else -> "bring"
            }
        }

        "CONOSCERE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "knows"
                else -> "know"
            }
        }

        "ANDARE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "goes"
                else -> "go"
            }
        }

        "INVIARE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "sends"
                else -> "send"
            }
        }

        "PRENDERE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "takes"
                else -> "take"
            }
        }

        "APRIRE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "opens"
                else -> "open"
            }
        }

        "GUARDARE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "looks"
                else -> "look"
            }
        }

        "CANTARE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "sings"
                else -> "sing"
            }
        }

        "CHIAMARE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "calls"
                else -> "call"
            }
        }

        "SIGILLARE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "seals"
                else -> "seal"
            }
        }

        "LAVORARE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "works"
                else -> "work"
            }
        }

        "SOLLEVARE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "lifts"
                else -> "lift"
            }
        }

        "NAVIGARE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "sails"
                else -> "sail"
            }
        }

        "SPLENDERE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "shines"
                else -> "shine"
            }
        }

        "PURIFICARE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "purifies"
                else -> "purify"
            }
        }

        "ARROSTIRE" -> {
            return when (pronoun) {
                "EGLI", "ELLA", "ESSO" -> "roasts"
                else -> "roast"
            }
        }

        else -> return verb
    }
}

/**
 * German present-tense conjugation. Unlike [conjugateVerbEn], German inflects
 * the verb for every person, not just 3rd-singular, so this mirrors the full
 * pronoun paradigm used by [conjugateVerbIt].
 */
fun conjugateVerbDe(verb: String, pronoun: String, hasObject: Boolean = false): String {
    val conjugated = conjugateVerbDePresent(verb, pronoun)
    // "die Felder arbeiten" is wrong: with an object German wants the transitive verb.
    return if (hasObject) GERMAN_TRANSITIVE_PREFIXES[verb]?.let { it + conjugated } ?: conjugated else conjugated
}

// Verbs whose German translation needs a prefix when they take a direct object.
private val GERMAN_TRANSITIVE_PREFIXES = mapOf("LAVORARE" to "be")

private fun conjugateVerbDePresent(verb: String, pronoun: String): String {
    val pronoun = normalizePronounKey(pronoun)
    when (verb) {
        "MANGIARE" -> {
            return when (pronoun) {
                "IO" -> "esse"
                "TU_M", "TU_F" -> "isst"
                "EGLI", "ELLA", "ESSO" -> "isst"
                "NOI" -> "essen"
                "VOI" -> "esst"
                "ESSI" -> "essen"
                else -> verb
            }
        }

        "DARE" -> {
            return when (pronoun) {
                "IO" -> "gebe"
                "TU_M", "TU_F" -> "gibst"
                "EGLI", "ELLA", "ESSO" -> "gibt"
                "NOI" -> "geben"
                "VOI" -> "gebt"
                "ESSI" -> "geben"
                else -> verb
            }
        }

        "ASCOLTARE" -> {
            return when (pronoun) {
                "IO" -> "höre"
                "TU_M", "TU_F" -> "hörst"
                "EGLI", "ELLA", "ESSO" -> "hört"
                "NOI" -> "hören"
                "VOI" -> "hört"
                "ESSI" -> "hören"
                else -> verb
            }
        }

        "DIRE" -> {
            return when (pronoun) {
                "IO" -> "sage"
                "TU_M", "TU_F" -> "sagst"
                "EGLI", "ELLA", "ESSO" -> "sagt"
                "NOI" -> "sagen"
                "VOI" -> "sagt"
                "ESSI" -> "sagen"
                else -> verb
            }
        }

        "BERE" -> {
            return when (pronoun) {
                "IO" -> "trinke"
                "TU_M", "TU_F" -> "trinkst"
                "EGLI", "ELLA", "ESSO" -> "trinkt"
                "NOI" -> "trinken"
                "VOI" -> "trinkt"
                "ESSI" -> "trinken"
                else -> verb
            }
        }

        "USCIRE" -> {
            return when (pronoun) {
                "IO" -> "gehe hinaus"
                "TU_M", "TU_F" -> "gehst hinaus"
                "EGLI", "ELLA", "ESSO" -> "geht hinaus"
                "NOI" -> "gehen hinaus"
                "VOI" -> "geht hinaus"
                "ESSI" -> "gehen hinaus"
                else -> verb
            }
        }

        "ENTRARE" -> {
            return when (pronoun) {
                "IO" -> "gehe hinein"
                "TU_M", "TU_F" -> "gehst hinein"
                "EGLI", "ELLA", "ESSO" -> "geht hinein"
                "NOI" -> "gehen hinein"
                "VOI" -> "geht hinein"
                "ESSI" -> "gehen hinein"
                else -> verb
            }
        }

        "AMARE" -> {
            return when (pronoun) {
                "IO" -> "liebe"
                "TU_M", "TU_F" -> "liebst"
                "EGLI", "ELLA", "ESSO" -> "liebt"
                "NOI" -> "lieben"
                "VOI" -> "liebt"
                "ESSI" -> "lieben"
                else -> verb
            }
        }

        "ESISTERE" -> {
            return when (pronoun) {
                "IO" -> "existiere"
                "TU_M", "TU_F" -> "existierst"
                "EGLI", "ELLA", "ESSO" -> "existiert"
                "NOI" -> "existieren"
                "VOI" -> "existiert"
                "ESSI" -> "existieren"
                else -> verb
            }
        }

        "VOLARE" -> {
            return when (pronoun) {
                "IO" -> "fliege"
                "TU_M", "TU_F" -> "fliegst"
                "EGLI", "ELLA", "ESSO" -> "fliegt"
                "NOI" -> "fliegen"
                "VOI" -> "fliegt"
                "ESSI" -> "fliegen"
                else -> verb
            }
        }

        "COLTIVARE" -> {
            return when (pronoun) {
                "IO" -> "kultiviere"
                "TU_M", "TU_F" -> "kultivierst"
                "EGLI", "ELLA", "ESSO" -> "kultiviert"
                "NOI" -> "kultivieren"
                "VOI" -> "kultiviert"
                "ESSI" -> "kultivieren"
                else -> verb
            }
        }

        "CACCIARE" -> {
            return when (pronoun) {
                "IO" -> "jage"
                "TU_M", "TU_F" -> "jagst"
                "EGLI", "ELLA", "ESSO" -> "jagt"
                "NOI" -> "jagen"
                "VOI" -> "jagt"
                "ESSI" -> "jagen"
                else -> verb
            }
        }

        "OFFRIRE" -> {
            return when (pronoun) {
                "IO" -> "biete"
                "TU_M", "TU_F" -> "bietest"
                "EGLI", "ELLA", "ESSO" -> "bietet"
                "NOI" -> "bieten"
                "VOI" -> "bietet"
                "ESSI" -> "bieten"
                else -> verb
            }
        }

        "SCRIVERE" -> {
            return when (pronoun) {
                "IO" -> "schreibe"
                "TU_M", "TU_F" -> "schreibst"
                "EGLI", "ELLA", "ESSO" -> "schreibt"
                "NOI" -> "schreiben"
                "VOI" -> "schreibt"
                "ESSI" -> "schreiben"
                else -> verb
            }
        }

        "VEDERE" -> {
            return when (pronoun) {
                "IO" -> "sehe"
                "TU_M", "TU_F" -> "siehst"
                "EGLI", "ELLA", "ESSO" -> "sieht"
                "NOI" -> "sehen"
                "VOI" -> "seht"
                "ESSI" -> "sehen"
                else -> verb
            }
        }

        "PARLARE" -> {
            return when (pronoun) {
                "IO" -> "spreche"
                "TU_M", "TU_F" -> "sprichst"
                "EGLI", "ELLA", "ESSO" -> "spricht"
                "NOI" -> "sprechen"
                "VOI" -> "sprecht"
                "ESSI" -> "sprechen"
                else -> verb
            }
        }

        "TROVARE" -> {
            return when (pronoun) {
                "IO" -> "finde"
                "TU_M", "TU_F" -> "findest"
                "EGLI", "ELLA", "ESSO" -> "findet"
                "NOI" -> "finden"
                "VOI" -> "findet"
                "ESSI" -> "finden"
                else -> verb
            }
        }

        "FARE" -> {
            return when (pronoun) {
                "IO" -> "mache"
                "TU_M", "TU_F" -> "machst"
                "EGLI", "ELLA", "ESSO" -> "macht"
                "NOI" -> "machen"
                "VOI" -> "macht"
                "ESSI" -> "machen"
                else -> verb
            }
        }

        "PORTARE" -> {
            return when (pronoun) {
                "IO" -> "bringe"
                "TU_M", "TU_F" -> "bringst"
                "EGLI", "ELLA", "ESSO" -> "bringt"
                "NOI" -> "bringen"
                "VOI" -> "bringt"
                "ESSI" -> "bringen"
                else -> verb
            }
        }

        "CONOSCERE" -> {
            return when (pronoun) {
                "IO" -> "kenne"
                "TU_M", "TU_F" -> "kennst"
                "EGLI", "ELLA", "ESSO" -> "kennt"
                "NOI" -> "kennen"
                "VOI" -> "kennt"
                "ESSI" -> "kennen"
                else -> verb
            }
        }

        "ANDARE" -> {
            return when (pronoun) {
                "IO" -> "gehe"
                "TU_M", "TU_F" -> "gehst"
                "EGLI", "ELLA", "ESSO" -> "geht"
                "NOI" -> "gehen"
                "VOI" -> "geht"
                "ESSI" -> "gehen"
                else -> verb
            }
        }

        "INVIARE" -> {
            return when (pronoun) {
                "IO" -> "sende"
                "TU_M", "TU_F" -> "sendest"
                "EGLI", "ELLA", "ESSO" -> "sendet"
                "NOI" -> "senden"
                "VOI" -> "sendet"
                "ESSI" -> "senden"
                else -> verb
            }
        }

        "PRENDERE" -> {
            return when (pronoun) {
                "IO" -> "nehme"
                "TU_M", "TU_F" -> "nimmst"
                "EGLI", "ELLA", "ESSO" -> "nimmt"
                "NOI" -> "nehmen"
                "VOI" -> "nehmt"
                "ESSI" -> "nehmen"
                else -> verb
            }
        }

        "APRIRE" -> {
            return when (pronoun) {
                "IO" -> "öffne"
                "TU_M", "TU_F" -> "öffnest"
                "EGLI", "ELLA", "ESSO" -> "öffnet"
                "NOI" -> "öffnen"
                "VOI" -> "öffnet"
                "ESSI" -> "öffnen"
                else -> verb
            }
        }

        "GUARDARE" -> {
            return when (pronoun) {
                "IO" -> "schaue"
                "TU_M", "TU_F" -> "schaust"
                "EGLI", "ELLA", "ESSO" -> "schaut"
                "NOI" -> "schauen"
                "VOI" -> "schaut"
                "ESSI" -> "schauen"
                else -> verb
            }
        }

        "CANTARE" -> {
            return when (pronoun) {
                "IO" -> "singe"
                "TU_M", "TU_F" -> "singst"
                "EGLI", "ELLA", "ESSO" -> "singt"
                "NOI" -> "singen"
                "VOI" -> "singt"
                "ESSI" -> "singen"
                else -> verb
            }
        }

        "CHIAMARE" -> {
            return when (pronoun) {
                "IO" -> "rufe"
                "TU_M", "TU_F" -> "rufst"
                "EGLI", "ELLA", "ESSO" -> "ruft"
                "NOI" -> "rufen"
                "VOI" -> "ruft"
                "ESSI" -> "rufen"
                else -> verb
            }
        }

        "SIGILLARE" -> {
            return when (pronoun) {
                "IO" -> "versiegle"
                "TU_M", "TU_F" -> "versiegelst"
                "EGLI", "ELLA", "ESSO" -> "versiegelt"
                "NOI" -> "versiegeln"
                "VOI" -> "versiegelt"
                "ESSI" -> "versiegeln"
                else -> verb
            }
        }

        "LAVORARE" -> {
            return when (pronoun) {
                "IO" -> "arbeite"
                "TU_M", "TU_F" -> "arbeitest"
                "EGLI", "ELLA", "ESSO" -> "arbeitet"
                "NOI" -> "arbeiten"
                "VOI" -> "arbeitet"
                "ESSI" -> "arbeiten"
                else -> verb
            }
        }

        "SOLLEVARE" -> {
            return when (pronoun) {
                "IO" -> "hebe"
                "TU_M", "TU_F" -> "hebst"
                "EGLI", "ELLA", "ESSO" -> "hebt"
                "NOI" -> "heben"
                "VOI" -> "hebt"
                "ESSI" -> "heben"
                else -> verb
            }
        }

        "NAVIGARE" -> {
            return when (pronoun) {
                "IO" -> "segle"
                "TU_M", "TU_F" -> "segelst"
                "EGLI", "ELLA", "ESSO" -> "segelt"
                "NOI" -> "segeln"
                "VOI" -> "segelt"
                "ESSI" -> "segeln"
                else -> verb
            }
        }

        "SPLENDERE" -> {
            return when (pronoun) {
                "IO" -> "strahle"
                "TU_M", "TU_F" -> "strahlst"
                "EGLI", "ELLA", "ESSO" -> "strahlt"
                "NOI" -> "strahlen"
                "VOI" -> "strahlt"
                "ESSI" -> "strahlen"
                else -> verb
            }
        }

        "PURIFICARE" -> {
            return when (pronoun) {
                "IO" -> "reinige"
                "TU_M", "TU_F" -> "reinigst"
                "EGLI", "ELLA", "ESSO" -> "reinigt"
                "NOI" -> "reinigen"
                "VOI" -> "reinigt"
                "ESSI" -> "reinigen"
                else -> verb
            }
        }

        "ARROSTIRE" -> {
            return when (pronoun) {
                "IO" -> "brate"
                "TU_M", "TU_F" -> "brätst"
                "EGLI", "ELLA", "ESSO" -> "brät"
                "NOI" -> "braten"
                "VOI" -> "bratet"
                "ESSI" -> "braten"
                else -> verb
            }
        }

        else -> return verb
    }
}

/**
 * Spanish present-tense conjugation. Inflects fully across 1st/2nd/3rd person singular and plural.
 */
fun conjugateVerbEs(verb: String, pronoun: String): String {
    val pronoun = normalizePronounKey(pronoun)
    when (verb) {
        "MANGIARE" -> {
            return when (pronoun) {
                "IO" -> "como"
                "TU_M", "TU_F" -> "comes"
                "EGLI", "ELLA", "ESSO" -> "come"
                "NOI" -> "comemos"
                "VOI" -> "coméis"
                "ESSI" -> "comen"
                else -> verb
            }
        }

        "DARE" -> {
            return when (pronoun) {
                "IO" -> "doy"
                "TU_M", "TU_F" -> "das"
                "EGLI", "ELLA", "ESSO" -> "da"
                "NOI" -> "damos"
                "VOI" -> "dais"
                "ESSI" -> "dan"
                else -> verb
            }
        }

        "ASCOLTARE" -> {
            return when (pronoun) {
                "IO" -> "escucho"
                "TU_M", "TU_F" -> "escuchas"
                "EGLI", "ELLA", "ESSO" -> "escucha"
                "NOI" -> "escuchamos"
                "VOI" -> "escucháis"
                "ESSI" -> "escuchan"
                else -> verb
            }
        }

        "DIRE" -> {
            return when (pronoun) {
                "IO" -> "digo"
                "TU_M", "TU_F" -> "dices"
                "EGLI", "ELLA", "ESSO" -> "dice"
                "NOI" -> "decimos"
                "VOI" -> "decís"
                "ESSI" -> "dicen"
                else -> verb
            }
        }

        "BERE" -> {
            return when (pronoun) {
                "IO" -> "bebo"
                "TU_M", "TU_F" -> "bebes"
                "EGLI", "ELLA", "ESSO" -> "bebe"
                "NOI" -> "bebemos"
                "VOI" -> "bebéis"
                "ESSI" -> "beben"
                else -> verb
            }
        }

        "USCIRE" -> {
            return when (pronoun) {
                "IO" -> "salgo"
                "TU_M", "TU_F" -> "sales"
                "EGLI", "ELLA", "ESSO" -> "sale"
                "NOI" -> "salimos"
                "VOI" -> "salís"
                "ESSI" -> "salen"
                else -> verb
            }
        }

        "ENTRARE" -> {
            return when (pronoun) {
                "IO" -> "entro"
                "TU_M", "TU_F" -> "entras"
                "EGLI", "ELLA", "ESSO" -> "entra"
                "NOI" -> "entramos"
                "VOI" -> "entráis"
                "ESSI" -> "entran"
                else -> verb
            }
        }

        "AMARE" -> {
            return when (pronoun) {
                "IO" -> "amo"
                "TU_M", "TU_F" -> "amas"
                "EGLI", "ELLA", "ESSO" -> "ama"
                "NOI" -> "amamos"
                "VOI" -> "amáis"
                "ESSI" -> "aman"
                else -> verb
            }
        }

        "ESISTERE" -> {
            return when (pronoun) {
                "IO" -> "existo"
                "TU_M", "TU_F" -> "existes"
                "EGLI", "ELLA", "ESSO" -> "existe"
                "NOI" -> "existimos"
                "VOI" -> "existís"
                "ESSI" -> "existen"
                else -> verb
            }
        }

        "VOLARE" -> {
            return when (pronoun) {
                "IO" -> "vuelo"
                "TU_M", "TU_F" -> "vuelas"
                "EGLI", "ELLA", "ESSO" -> "vuela"
                "NOI" -> "volamos"
                "VOI" -> "voláis"
                "ESSI" -> "vuelan"
                else -> verb
            }
        }

        "COLTIVARE" -> {
            return when (pronoun) {
                "IO" -> "cultivo"
                "TU_M", "TU_F" -> "cultivas"
                "EGLI", "ELLA", "ESSO" -> "cultiva"
                "NOI" -> "cultivamos"
                "VOI" -> "cultiváis"
                "ESSI" -> "cultivan"
                else -> verb
            }
        }

        "CACCIARE" -> {
            return when (pronoun) {
                "IO" -> "cazo"
                "TU_M", "TU_F" -> "cazas"
                "EGLI", "ELLA", "ESSO" -> "caza"
                "NOI" -> "cazamos"
                "VOI" -> "cazáis"
                "ESSI" -> "cazan"
                else -> verb
            }
        }

        "OFFRIRE" -> {
            return when (pronoun) {
                "IO" -> "ofrezco"
                "TU_M", "TU_F" -> "ofreces"
                "EGLI", "ELLA", "ESSO" -> "ofrece"
                "NOI" -> "ofrecemos"
                "VOI" -> "ofrecéis"
                "ESSI" -> "ofrecen"
                else -> verb
            }
        }

        "VEDERE" -> {
            return when (pronoun) {
                "IO" -> "veo"
                "TU_M", "TU_F" -> "ves"
                "EGLI", "ELLA", "ESSO" -> "ve"
                "NOI" -> "vemos"
                "VOI" -> "veis"
                "ESSI" -> "ven"
                else -> verb
            }
        }

        "SCRIVERE" -> {
            return when (pronoun) {
                "IO" -> "escribo"
                "TU_M", "TU_F" -> "escribes"
                "EGLI", "ELLA", "ESSO" -> "escribe"
                "NOI" -> "escribimos"
                "VOI" -> "escribís"
                "ESSI" -> "escriben"
                else -> verb
            }
        }

        "PARLARE" -> {
            return when (pronoun) {
                "IO" -> "hablo"
                "TU_M", "TU_F" -> "hablas"
                "EGLI", "ELLA", "ESSO" -> "habla"
                "NOI" -> "hablamos"
                "VOI" -> "habláis"
                "ESSI" -> "hablan"
                else -> verb
            }
        }

        "TROVARE" -> {
            return when (pronoun) {
                "IO" -> "encuentro"
                "TU_M", "TU_F" -> "encuentras"
                "EGLI", "ELLA", "ESSO" -> "encuentra"
                "NOI" -> "encontramos"
                "VOI" -> "encontráis"
                "ESSI" -> "encuentran"
                else -> verb
            }
        }

        "FARE" -> {
            return when (pronoun) {
                "IO" -> "hago"
                "TU_M", "TU_F" -> "haces"
                "EGLI", "ELLA", "ESSO" -> "hace"
                "NOI" -> "hacemos"
                "VOI" -> "hacéis"
                "ESSI" -> "hacen"
                else -> verb
            }
        }

        "PORTARE" -> {
            return when (pronoun) {
                "IO" -> "llevo"
                "TU_M", "TU_F" -> "llevas"
                "EGLI", "ELLA", "ESSO" -> "lleva"
                "NOI" -> "llevamos"
                "VOI" -> "lleváis"
                "ESSI" -> "llevan"
                else -> verb
            }
        }

        "CONOSCERE" -> {
            return when (pronoun) {
                "IO" -> "conozco"
                "TU_M", "TU_F" -> "conoces"
                "EGLI", "ELLA", "ESSO" -> "conoce"
                "NOI" -> "conocemos"
                "VOI" -> "conocéis"
                "ESSI" -> "conocen"
                else -> verb
            }
        }

        "ANDARE" -> {
            return when (pronoun) {
                "IO" -> "voy"
                "TU_M", "TU_F" -> "vas"
                "EGLI", "ELLA", "ESSO" -> "va"
                "NOI" -> "vamos"
                "VOI" -> "vais"
                "ESSI" -> "van"
                else -> verb
            }
        }

        "INVIARE" -> {
            return when (pronoun) {
                "IO" -> "envío"
                "TU_M", "TU_F" -> "envías"
                "EGLI", "ELLA", "ESSO" -> "envía"
                "NOI" -> "enviamos"
                "VOI" -> "enviáis"
                "ESSI" -> "envían"
                else -> verb
            }
        }

        "PRENDERE" -> {
            return when (pronoun) {
                "IO" -> "tomo"
                "TU_M", "TU_F" -> "tomas"
                "EGLI", "ELLA", "ESSO" -> "toma"
                "NOI" -> "tomamos"
                "VOI" -> "tomáis"
                "ESSI" -> "toman"
                else -> verb
            }
        }

        "APRIRE" -> {
            return when (pronoun) {
                "IO" -> "abro"
                "TU_M", "TU_F" -> "abres"
                "EGLI", "ELLA", "ESSO" -> "abre"
                "NOI" -> "abrimos"
                "VOI" -> "abrís"
                "ESSI" -> "abren"
                else -> verb
            }
        }

        "GUARDARE" -> {
            return when (pronoun) {
                "IO" -> "miro"
                "TU_M", "TU_F" -> "miras"
                "EGLI", "ELLA", "ESSO" -> "mira"
                "NOI" -> "miramos"
                "VOI" -> "miráis"
                "ESSI" -> "miran"
                else -> verb
            }
        }

        "CANTARE" -> {
            return when (pronoun) {
                "IO" -> "canto"
                "TU_M", "TU_F" -> "cantas"
                "EGLI", "ELLA", "ESSO" -> "canta"
                "NOI" -> "cantamos"
                "VOI" -> "cantáis"
                "ESSI" -> "cantan"
                else -> verb
            }
        }

        "CHIAMARE" -> {
            return when (pronoun) {
                "IO" -> "llamo"
                "TU_M", "TU_F" -> "llamas"
                "EGLI", "ELLA", "ESSO" -> "llama"
                "NOI" -> "llamamos"
                "VOI" -> "llamáis"
                "ESSI" -> "llaman"
                else -> verb
            }
        }

        "SIGILLARE" -> {
            return when (pronoun) {
                "IO" -> "sello"
                "TU_M", "TU_F" -> "sellas"
                "EGLI", "ELLA", "ESSO" -> "sella"
                "NOI" -> "sellamos"
                "VOI" -> "selláis"
                "ESSI" -> "sellan"
                else -> verb
            }
        }

        "LAVORARE" -> {
            return when (pronoun) {
                "IO" -> "trabajo"
                "TU_M", "TU_F" -> "trabajas"
                "EGLI", "ELLA", "ESSO" -> "trabaja"
                "NOI" -> "trabajamos"
                "VOI" -> "trabajáis"
                "ESSI" -> "trabajan"
                else -> verb
            }
        }

        "SOLLEVARE" -> {
            return when (pronoun) {
                "IO" -> "levanto"
                "TU_M", "TU_F" -> "levantas"
                "EGLI", "ELLA", "ESSO" -> "levanta"
                "NOI" -> "levantamos"
                "VOI" -> "levantáis"
                "ESSI" -> "levantan"
                else -> verb
            }
        }

        "NAVIGARE" -> {
            return when (pronoun) {
                "IO" -> "navego"
                "TU_M", "TU_F" -> "navegas"
                "EGLI", "ELLA", "ESSO" -> "navega"
                "NOI" -> "navegamos"
                "VOI" -> "navegáis"
                "ESSI" -> "navegan"
                else -> verb
            }
        }

        "SPLENDERE" -> {
            return when (pronoun) {
                "IO" -> "brillo"
                "TU_M", "TU_F" -> "brillas"
                "EGLI", "ELLA", "ESSO" -> "brilla"
                "NOI" -> "brillamos"
                "VOI" -> "brilláis"
                "ESSI" -> "brillan"
                else -> verb
            }
        }

        "PURIFICARE" -> {
            return when (pronoun) {
                "IO" -> "purifico"
                "TU_M", "TU_F" -> "purificas"
                "EGLI", "ELLA", "ESSO" -> "purifica"
                "NOI" -> "purificamos"
                "VOI" -> "purificáis"
                "ESSI" -> "purifican"
                else -> verb
            }
        }

        "ARROSTIRE" -> {
            return when (pronoun) {
                "IO" -> "aso"
                "TU_M", "TU_F" -> "asas"
                "EGLI", "ELLA", "ESSO" -> "asa"
                "NOI" -> "asamos"
                "VOI" -> "asáis"
                "ESSI" -> "asan"
                else -> verb
            }
        }

        else -> return verb
    }
}

fun conjugateVerbFr(verb: String, pronoun: String): String {
    val pronoun = normalizePronounKey(pronoun)
    when (verb) {
        "MANGIARE" -> {
            return when (pronoun) {
                "IO" -> "mange"
                "TU_M", "TU_F" -> "manges"
                "EGLI", "ELLA", "ESSO" -> "mange"
                "NOI" -> "mangeons"
                "VOI" -> "mangez"
                "ESSI" -> "mangent"
                else -> verb
            }
        }

        "DARE" -> {
            return when (pronoun) {
                "IO" -> "donne"
                "TU_M", "TU_F" -> "donnes"
                "EGLI", "ELLA", "ESSO" -> "donne"
                "NOI" -> "donnons"
                "VOI" -> "donnez"
                "ESSI" -> "donnent"
                else -> verb
            }
        }

        "ASCOLTARE" -> {
            return when (pronoun) {
                "IO" -> "écoute"
                "TU_M", "TU_F" -> "écoutes"
                "EGLI", "ELLA", "ESSO" -> "écoute"
                "NOI" -> "écoutons"
                "VOI" -> "écoutez"
                "ESSI" -> "écoutent"
                else -> verb
            }
        }

        "DIRE" -> {
            return when (pronoun) {
                "IO" -> "dis"
                "TU_M", "TU_F" -> "dis"
                "EGLI", "ELLA", "ESSO" -> "dit"
                "NOI" -> "disons"
                "VOI" -> "dites"
                "ESSI" -> "disent"
                else -> verb
            }
        }

        "BERE" -> {
            return when (pronoun) {
                "IO" -> "bois"
                "TU_M", "TU_F" -> "bois"
                "EGLI", "ELLA", "ESSO" -> "boit"
                "NOI" -> "buvons"
                "VOI" -> "buvez"
                "ESSI" -> "boivent"
                else -> verb
            }
        }

        "USCIRE" -> {
            return when (pronoun) {
                "IO" -> "sors"
                "TU_M", "TU_F" -> "sors"
                "EGLI", "ELLA", "ESSO" -> "sort"
                "NOI" -> "sortons"
                "VOI" -> "sortez"
                "ESSI" -> "sortent"
                else -> verb
            }
        }

        "ENTRARE" -> {
            return when (pronoun) {
                "IO" -> "entre"
                "TU_M", "TU_F" -> "entres"
                "EGLI", "ELLA", "ESSO" -> "entre"
                "NOI" -> "entrons"
                "VOI" -> "entrez"
                "ESSI" -> "entrent"
                else -> verb
            }
        }

        "AMARE" -> {
            return when (pronoun) {
                "IO" -> "aime"
                "TU_M", "TU_F" -> "aimes"
                "EGLI", "ELLA", "ESSO" -> "aime"
                "NOI" -> "aimons"
                "VOI" -> "aimez"
                "ESSI" -> "aiment"
                else -> verb
            }
        }

        "ESISTERE" -> {
            return when (pronoun) {
                "IO" -> "existe"
                "TU_M", "TU_F" -> "existes"
                "EGLI", "ELLA", "ESSO" -> "existe"
                "NOI" -> "existons"
                "VOI" -> "existez"
                "ESSI" -> "existent"
                else -> verb
            }
        }

        "VOLARE" -> {
            return when (pronoun) {
                "IO" -> "vole"
                "TU_M", "TU_F" -> "voles"
                "EGLI", "ELLA", "ESSO" -> "vole"
                "NOI" -> "volons"
                "VOI" -> "volez"
                "ESSI" -> "volent"
                else -> verb
            }
        }

        "COLTIVARE" -> {
            return when (pronoun) {
                "IO" -> "cultive"
                "TU_M", "TU_F" -> "cultives"
                "EGLI", "ELLA", "ESSO" -> "cultive"
                "NOI" -> "cultivons"
                "VOI" -> "cultivez"
                "ESSI" -> "cultivent"
                else -> verb
            }
        }

        "CACCIARE" -> {
            return when (pronoun) {
                "IO" -> "chasse"
                "TU_M", "TU_F" -> "chasses"
                "EGLI", "ELLA", "ESSO" -> "chasse"
                "NOI" -> "chassons"
                "VOI" -> "chassez"
                "ESSI" -> "chassent"
                else -> verb
            }
        }

        "OFFRIRE" -> {
            return when (pronoun) {
                "IO" -> "offre"
                "TU_M", "TU_F" -> "offres"
                "EGLI", "ELLA", "ESSO" -> "offre"
                "NOI" -> "offrons"
                "VOI" -> "offrez"
                "ESSI" -> "offrent"
                else -> verb
            }
        }

        "SCRIVERE" -> {
            return when (pronoun) {
                "IO" -> "écris"
                "TU_M", "TU_F" -> "écris"
                "EGLI", "ELLA", "ESSO" -> "écrit"
                "NOI" -> "écrivons"
                "VOI" -> "écrivez"
                "ESSI" -> "écrivent"
                else -> verb
            }
        }

        "VEDERE" -> {
            return when (pronoun) {
                "IO" -> "vois"
                "TU_M", "TU_F" -> "vois"
                "EGLI", "ELLA", "ESSO" -> "voit"
                "NOI" -> "voyons"
                "VOI" -> "voyez"
                "ESSI" -> "voient"
                else -> verb
            }
        }

        "PARLARE" -> {
            return when (pronoun) {
                "IO" -> "parle"
                "TU_M", "TU_F" -> "parles"
                "EGLI", "ELLA", "ESSO" -> "parle"
                "NOI" -> "parlons"
                "VOI" -> "parlez"
                "ESSI" -> "parlent"
                else -> verb
            }
        }

        "TROVARE" -> {
            return when (pronoun) {
                "IO" -> "trouve"
                "TU_M", "TU_F" -> "trouves"
                "EGLI", "ELLA", "ESSO" -> "trouve"
                "NOI" -> "trouvons"
                "VOI" -> "trouvez"
                "ESSI" -> "trouvent"
                else -> verb
            }
        }

        "FARE" -> {
            return when (pronoun) {
                "IO" -> "fais"
                "TU_M", "TU_F" -> "fais"
                "EGLI", "ELLA", "ESSO" -> "fait"
                "NOI" -> "faisons"
                "VOI" -> "faites"
                "ESSI" -> "font"
                else -> verb
            }
        }

        "PORTARE" -> {
            return when (pronoun) {
                "IO" -> "porte"
                "TU_M", "TU_F" -> "portes"
                "EGLI", "ELLA", "ESSO" -> "porte"
                "NOI" -> "portons"
                "VOI" -> "portez"
                "ESSI" -> "portent"
                else -> verb
            }
        }

        "CONOSCERE" -> {
            return when (pronoun) {
                "IO" -> "connais"
                "TU_M", "TU_F" -> "connais"
                "EGLI", "ELLA", "ESSO" -> "connaît"
                "NOI" -> "connaissons"
                "VOI" -> "connaissez"
                "ESSI" -> "connaissent"
                else -> verb
            }
        }

        "ANDARE" -> {
            return when (pronoun) {
                "IO" -> "vais"
                "TU_M", "TU_F" -> "vas"
                "EGLI", "ELLA", "ESSO" -> "va"
                "NOI" -> "allons"
                "VOI" -> "allez"
                "ESSI" -> "vont"
                else -> verb
            }
        }

        "INVIARE" -> {
            return when (pronoun) {
                "IO" -> "envoie"
                "TU_M", "TU_F" -> "envoies"
                "EGLI", "ELLA", "ESSO" -> "envoie"
                "NOI" -> "envoyons"
                "VOI" -> "envoyez"
                "ESSI" -> "envoient"
                else -> verb
            }
        }

        "PRENDERE" -> {
            return when (pronoun) {
                "IO" -> "prends"
                "TU_M", "TU_F" -> "prends"
                "EGLI", "ELLA", "ESSO" -> "prend"
                "NOI" -> "prenons"
                "VOI" -> "prenez"
                "ESSI" -> "prennent"
                else -> verb
            }
        }

        "APRIRE" -> {
            return when (pronoun) {
                "IO" -> "ouvre"
                "TU_M", "TU_F" -> "ouvres"
                "EGLI", "ELLA", "ESSO" -> "ouvre"
                "NOI" -> "ouvrons"
                "VOI" -> "ouvrez"
                "ESSI" -> "ouvrent"
                else -> verb
            }
        }

        "GUARDARE" -> {
            return when (pronoun) {
                "IO" -> "regarde"
                "TU_M", "TU_F" -> "regardes"
                "EGLI", "ELLA", "ESSO" -> "regarde"
                "NOI" -> "regardons"
                "VOI" -> "regardez"
                "ESSI" -> "regardent"
                else -> verb
            }
        }

        "CANTARE" -> {
            return when (pronoun) {
                "IO" -> "chante"
                "TU_M", "TU_F" -> "chantes"
                "EGLI", "ELLA", "ESSO" -> "chante"
                "NOI" -> "chantons"
                "VOI" -> "chantez"
                "ESSI" -> "chantent"
                else -> verb
            }
        }

        "CHIAMARE" -> {
            return when (pronoun) {
                "IO" -> "appelle"
                "TU_M", "TU_F" -> "appelles"
                "EGLI", "ELLA", "ESSO" -> "appelle"
                "NOI" -> "appelons"
                "VOI" -> "appelez"
                "ESSI" -> "appellent"
                else -> verb
            }
        }

        "SIGILLARE" -> {
            return when (pronoun) {
                "IO" -> "scelle"
                "TU_M", "TU_F" -> "scelles"
                "EGLI", "ELLA", "ESSO" -> "scelle"
                "NOI" -> "scellons"
                "VOI" -> "scellez"
                "ESSI" -> "scellent"
                else -> verb
            }
        }

        "LAVORARE" -> {
            return when (pronoun) {
                "IO" -> "travaille"
                "TU_M", "TU_F" -> "travailles"
                "EGLI", "ELLA", "ESSO" -> "travaille"
                "NOI" -> "travaillons"
                "VOI" -> "travaillez"
                "ESSI" -> "travaillent"
                else -> verb
            }
        }

        "SOLLEVARE" -> {
            return when (pronoun) {
                "IO" -> "soulève"
                "TU_M", "TU_F" -> "soulèves"
                "EGLI", "ELLA", "ESSO" -> "soulève"
                "NOI" -> "soulevons"
                "VOI" -> "soulevez"
                "ESSI" -> "soulèvent"
                else -> verb
            }
        }

        "NAVIGARE" -> {
            return when (pronoun) {
                "IO" -> "navigue"
                "TU_M", "TU_F" -> "navigues"
                "EGLI", "ELLA", "ESSO" -> "navigue"
                "NOI" -> "naviguons"
                "VOI" -> "naviguez"
                "ESSI" -> "naviguent"
                else -> verb
            }
        }

        "SPLENDERE" -> {
            return when (pronoun) {
                "IO" -> "brille"
                "TU_M", "TU_F" -> "brilles"
                "EGLI", "ELLA", "ESSO" -> "brille"
                "NOI" -> "brillons"
                "VOI" -> "brillez"
                "ESSI" -> "brillent"
                else -> verb
            }
        }

        "PURIFICARE" -> {
            return when (pronoun) {
                "IO" -> "purifie"
                "TU_M", "TU_F" -> "purifies"
                "EGLI", "ELLA", "ESSO" -> "purifie"
                "NOI" -> "purifions"
                "VOI" -> "purifiez"
                "ESSI" -> "purifient"
                else -> verb
            }
        }

        "ARROSTIRE" -> {
            return when (pronoun) {
                "IO" -> "rôtis"
                "TU_M", "TU_F" -> "rôtis"
                "EGLI", "ELLA", "ESSO" -> "rôtit"
                "NOI" -> "rôtissons"
                "VOI" -> "rôtissez"
                "ESSI" -> "rôtissent"
                else -> verb
            }
        }

        else -> return verb
    }
}

